import React from 'react';
import Modal from 'react-bootstrap/Modal';
const TermsService = (props) => {
    return (<>

        <Modal
            {...props}
            size="xl"
            aria-labelledby="example-modal-sizes-title-lg"
        >
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
                <div className="terms_container container">
                    <header>
                        {/* <h1>NMT Security – Terms of Service</h1> */}
                        <h1>NMT SECURITY END USER SaaS AGREEMENT </h1>
                        <p className='mb-5'><strong>Last Modified:</strong> Aug 11, 2025</p>
                    </header>
                    <div className='hieght_scroll'>
                        <section>
                            <p>
                                These Terms of Service (“Terms”) are entered into by and between you (“Client” or “You”) and NMT Security Pvt. Ltd. (India) or NMT Security Inc. (U.S.) (collectively “NMT Security,” “we,” or “us”). They govern your use of the NMT Security platform, services, and website (collectively, “Service”), whether accessed as a guest or registered user. Your access and use of the Service signify your acceptance of these Terms and our Privacy Policy.
                            </p>
                        </section>


                        <section>
                            <h2> 1. License & Account</h2>
                            <p>
                                <strong>1.1 License Grant : </strong> <br />license to use the Service based on your Subscription Plan.
                            </p>
                            <p>
                                <strong>1.2 Account Registration : </strong> <br />You must create an account (“Account”) to use the Service. Provide accurate information, maintain one active account, and keep credentials secure.
                            </p>
                            <p>
                                <strong>1.3 Authorized Use : </strong>
                            </p>
                            <p>
                                You Must
                                <ul>
                                    <li>
                                        Be 18+ and have authority to agree to these Terms;
                                    </li>
                                    <li>Only use the Service for lawful purposes;</li>
                                    <li>Prevent unauthorized access or sharing of your Account;</li>
                                    <li>Not use the Service to resell competing solutions or perform illegal activities.</li>

                                </ul>
                            </p>
                        </section>

                        <section>
                            <h2>2. Subscription Plans & Usage Limits
                            </h2>
                            <p>Service features, billing, and usage limits vary by tier (Freemium, Detect, Protect, Prevent). Each plan includes specific limits on domains, assets, and support levels as described in your plan documentation. Exceeding limits requires upgrading or incurs additional fees. You agree to pay all applicable fees per your plan.
                            </p>

                        </section>
                        <section>
                            <h2>3. Freemium Plan Disclaimer </h2>
                            <p>
                                Freemium accounts are provided “as-is” without warranties, SLA, or liability. NMT Security may modify, limit, or suspend free access at any time without notice. Your free-tier data may be used for internal improvements and threat intelligence.
                            </p>

                        </section>
                        <section>
                            <h2>4. Billing, Renewal & Cancellation
                            </h2>
                            <p>
                                <strong>4.1 Payment : </strong> <br />Paid plans are billed monthly or annually, in INR or USD depending on region. Fees are due within 30 days of invoice.
                            </p>
                            <p>
                                <strong>4.2 Renewal : </strong> <br />Annual plans auto-renew unless canceled 15 days before renewal date. Downgrades take effect at the next billing cycle.
                            </p>
                            <p>
                                <strong>4.3 Termination : </strong> <br /> To cancel, submit written notice 15 days before renewal. No refunds are issued for early termination unless required by law.
                            </p>
                            <p>
                                4.4 Data Collection, Processing & Third-Party Access Authorization
                            </p>
                            <p>
                                By subscribing to, registering for, or using any NMT Security plan (including Freemium, paid subscriptions, trials, and beta services), you expressly:</p>
                            <ul>

                                <li>
                                    <p>
                                        <strong>1. Consent to Data Processing : </strong> Authorize NMT Security to collect, process, store, and analyze your data, including personally identifiable information (PII) and system metadata, as described in the NMT Security Privacy Policy, for the purposes of delivering, improving, and securing the Services.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <strong>2. Third-Party Data Retrieval : </strong> Authorize NMT Security to retrieve and process data about you, your organization, and your systems from third-party services, vendors, and data providers on your behalf. This includes, but is not limited to, domain registrars, security intelligence feeds, vulnerability databases, and compliance platforms, solely for delivering the agreed Services.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <strong>3. Authorization & Representation : </strong> Represent and warrant that you have the legal right and authority to grant NMT Security such access and to authorize retrieval of data from relevant third parties.
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <strong>4. Data Use Limitation : </strong> Agree that any data accessed or retrieved under this authorization will be handled in accordance with the NMT Security Privacy Policy and applicable data protection laws (including DPDP, GDPR, and CCPA where applicable).

                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <strong>5. Revocation of Consent : </strong> Understand that you may withdraw this authorization at any time by providing written notice to NMT Security; however, withdrawal may result in reduced functionality or termination of the Services.

                                    </p>
                                </li>
                            </ul>
                        </section>
                        <section>
                            <h2>5. Scope of Services
                            </h2>
                            <p> NMT Security will deliver features and services described in your subscription tier, including but not limited to:</p>
                            <ul>
                                <li>External Exposure analysis</li>
                                <li>Email security configuration & management</li>
                                <li> Brand monitoring & takedown support</li>
                                <li>Application and network vulnerability scanning</li>
                                <li>Public exposure and dark web intelligence</li>
                                <li>Governance, compliance templates, and vCISO/DPO services</li>
                                <li>Pen test add-ons, support, and integrations</li>

                            </ul>
                            <p>Tier-specific responsibilities and deliverables are described in your plan documentation.
                            </p>
                        </section>
                        <section>
                            <h2> 6. Customer Obligations
                            </h2>
                            <p> You must:
                            </p>
                            <ul>
                                <li>
                                    Provide required account and system access</li>
                                <li> Maintain ownership of systems monitored</li>
                                <li>Cooperate with remediation efforts</li>
                                <li>Ensure lawful use of the Service</li>
                                <li> Secure API keys and passwords</li>

                            </ul>
                        </section>
                        <section>
                            <h2>7. Third-Party Risk & Integration
                            </h2>
                            <p>
                                We integrate with third-party data providers (VirusTotal, AbuseIPDB, OTX, etc.) to enhance security visibility. You hereby consent to data sharing with these services. NMT Security is not responsible for errors or inaccuracies from third-party sources.

                            </p>
                        </section>
                        <section>
                            <h2>8. Intellectual Property
                            </h2>
                            <p>All Service components—including tools, code, trademarks, and data—remain our sole property. You receive only a limited license to access and use the Service. You may not copy, modify, reverse-engineer, or redistribute the Service.
                            </p>

                        </section>

                        <section className='mt-5'>
                            <h2>9. Confidentiality & Data Security
                            </h2>
                            <p>We use industry-standard security and comply with relevant regulations (DPDP, CCPA, GDPR). We maintain confidentiality over your data and findings. You are responsible for the security of credentials and other access mechanisms.
                            </p>

                        </section>
                        <section>
                            <h2>10. Warranties & Disclaimers </h2>
                            <p>Freemium accounts are provided “as-is” without warranties, SLA, or liability. NMT Security may modify, limit, or suspend free access at any time without notice. Your free-tier data may be used for internal improvements and threat intelligence.
                            </p>
                            <h3>10.1 Service Warranty
                            </h3>
                            <p>We will provide Services in a professional manner consistent with industry standards.
                            </p>
                            <h3>10.2 Disclaimersl</h3>
                            <p>Except as expressly stated, the Service is provided “as-is” without warranties or guarantees; performance, availability, and remediation are not guaranteed.</p>
                            <h3>10.3 Freemium Specific</h3>
                            <p>No support, warranties, or guarantees apply to Freemium users.</p>
                        </section>

                        <section>
                            <h2>11. Limitation of Liability
                            </h2>
                            <p>
                                To the extent permitted by law:

                            </p>
                            <ul>
                                <li>Neither party is liable for indirect, incidental, or consequential damages.</li>
                                <li>NMT Security’s total liability is capped at one month’s subscription fee.
                                </li>
                            </ul>
                        </section>
                        <section>
                            <h2>12. Indemnity
                            </h2>
                            <p>
                                You agree to indemnify NMT Security and its affiliates against third-party claims related to your use of the Service, violation of these Terms, or breach of applicable law.
                            </p>

                        </section>
                        <section>
                            <h2>13. Service Change & Notice
                            </h2>
                            <p>
                                We may modify, suspend, or discontinue features with notice:

                            </p>
                            <ul>
                                <li>7 days’ notice for Freemium or Detect tier changes
                                </li>
                                <li>30 days’ notice for Protect or Prevent tier changes
                                </li>
                            </ul>

                        </section>
                        <section>
                            <h2>14. Term & Termination
                            </h2>
                            <p>These Terms remain in effect while you have an active subscription. We may terminate or suspend access if you violate these Terms, without affecting accrued rights. Upon termination, paid data may be archived or destroyed per applicable law.
                            </p>

                        </section>
                        <section>
                            <h2> 15. Governing Law & Dispute Resolution
                            </h2>
                            <p>NMT Security retains all rights, title, and interest in the Services. Customer retains rights to Customer Data but grants NMT Security the right to use anonymized, aggregated data for analytics and improvement. </p>

                            <ul>
                                <li>India: Governed by IT Act, 2000 and DPDP Act, 2023. Disputes resolved in Bengaluru courts.
                                </li>
                                <li>U.S. & Other Regions: Governed by Delaware law. Disputes in Delaware courts.</li>
                            </ul>
                        </section>
                        <section>
                            <h2> 16. Notices   </h2>
                            <p>Each party will protect the other's confidential information, using reasonable care, and disclose only to authorized personnel as necessary.
                            </p>
                        </section>
                        <section>
                            <p>All notices must be in writing and sent to:
                            </p>
                            <p>India</p>
                            <p>NMT Security Innovations Pvt. Ltd.
                            </p>
                            <p>#301, 3rd Floor, ALT F, Sector 142, Noida, UP 201304
                            </p>
                            <strong>Email: </strong> <a className='color_white' href="mailto:info@nmtsecurity.com"> info@nmtsecurity.com </a>
                            <p>U.S</p>
                            <p>NMT Security LLC
                            </p>
                            <p>10 Ruffin CT, Tinton Falls, NJ 07724
                            </p>
                            <strong>Email: </strong> <a className='color_white' href="mailto:info@nmtsecurity.com"> info@nmtsecurity.com </a>

                        </section>
                        <section>
                            <h2>17. General Provisions</h2>
                            <ul>
                                <li>
                                    No Waiver: Failure to enforce rights does not waive them.
                                </li>
                                <li>
                                    Severability: Invalid provisions do not affect the rest.
                                </li>
                                <li>
                                    Entire Agreement: These Terms, your Subscription Order, and Privacy Policy constitute the full agreement.
                                </li>
                                <li>
                                    Assignment: You may not assign rights without NMT’s consent; we may assign freely.
                                </li>
                            </ul>
                        </section>

                    </div>
                </div>
            </Modal.Body>
        </Modal>
    </>
    );
}
export default TermsService;
